import { render } from "./trading-accounts-edit.vue?vue&type=template&id=43782d18"
import script from "./trading-accounts-edit.vue?vue&type=script&lang=js"
export * from "./trading-accounts-edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__